<template>
	<section class="content-wrapper">
		<router-link to="/" exact class="btn btn-back">
			<img
				src="images/chevron-left-green.svg"
				style="margin-right: 6px"
			/>powrót
		</router-link>

		<h1>ankieta MIFID</h1>
		<div class="text-container">
			<mifid-content :card="true" />
			<br />

			<a
				v-if="!user.isCompany"
				:href="user.surveyPoolUrl"
				rel="noopener noreferrer nofollow"
				class="btn btn-primary mt-2 text-white"
				style="color: white !important"
			>
				wypełnienie ankiety
			</a>
		</div>
		<br />
		<router-link
			to="/"
			v-if="windowWidth < mobileBreakpoint"
			exact
			class="btn btn-secondary"
			>powrót</router-link
		>
	</section>
</template>

<script>
import MifidContent from '@/views/mifid/partial/_MifidContent';
import { mapGetters } from 'vuex';

export default {
	methods: {
		mifidQUestionaire() {
			this.$store.dispatch('pollRefill', false);
		},
	},
	components: {
		MifidContent,
	},
	computed: {
		windowWidth() {
			return this.$store.getters.getWindowWidth;
		},
		user() {
			return this.$store.getters.getUser
				? this.$store.getters.getUser
				: false;
		},
		...mapGetters({ mobileBreakpoint: 'getMobileBreakpoing' }),
	},
};
</script>
